import { FunctionComponent } from "react";
import { clientTheme } from "@ui-kit/ConfigProvider";

import "./Loader.css";

interface LoaderProps {
  size?: "small" | "medium" | "large";
}

const sizeMap = {
  small: 24,
  medium: 32,
  large: 42,
};

const Loader: FunctionComponent<LoaderProps> = ({ size = "medium" }) => {
  return (
    <div className="loader-component">
      <svg viewBox="0 0 32 32" width={sizeMap[size]} height={sizeMap[size]}>
        <circle
          id="spinner"
          cx="16"
          cy="16"
          r="14"
          fill="none"
          stroke={clientTheme.colorPrimary}></circle>
      </svg>
    </div>
  );
};

export { Loader };
